module.exports = __webpack_public_path__ + "public/Icons/userIcon.svg?a578b9cb";